import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { listExtensions } from '../../services/extension.service';
import { ExtensionUiLoader } from '../../extensions/registry';

const apiUrl = window._env_?.REACT_APP_API_URL || 'https://app.mylocaleventrentals.com/api';

const ExtensionsTab = () => {
  const [extensions, setExtensions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setLoading(false);
      return;
    }

    const load = async () => {
      try {
        const profile = await axios.get(`${apiUrl}/user/profile`, {
          headers: { 'x-auth-token': token },
        });
        const role = String(profile.data.user?.role || '').toLowerCase();
        setIsAdmin(role === 'admin');

        const res = await listExtensions();
        setExtensions(res.data.data || []);
        if (res.data.data?.length > 0) {
          setSelected(res.data.data[0].name);
        }
      } catch (err) {
        console.error('Failed to load extensions:', err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  if (loading) return <p className="text-sm text-gray-500">Loading extensions…</p>;

  if (!isAdmin) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg text-sm text-yellow-800">
        Extension settings require admin access.
      </div>
    );
  }

  const selectedExt = extensions.find((e) => e.name === selected);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg border border-gray-200 p-4">
          <h3 className="font-medium text-gray-900 mb-3">Installed Extensions</h3>
          <ul className="space-y-2">
            {extensions.map((ext) => (
              <li key={ext.name}>
                <button
                  type="button"
                  onClick={() => setSelected(ext.name)}
                  className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors ${
                    selected === ext.name
                      ? 'bg-blue-50 text-blue-700 font-medium'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span>{ext.displayName || ext.name}</span>
                    <span
                      className={`text-xs px-2 py-0.5 rounded-full ${
                        ext.enabled
                          ? 'bg-green-100 text-green-700'
                          : 'bg-gray-100 text-gray-600'
                      }`}
                    >
                      {ext.enabled ? 'Enabled' : 'Disabled'}
                    </span>
                  </div>
                </button>
              </li>
            ))}
            {extensions.length === 0 && (
              <li className="text-sm text-gray-500">No extensions installed.</li>
            )}
          </ul>
        </div>

        <div className="lg:col-span-2">
          {selectedExt ? (
            <div className="bg-white rounded-lg border border-gray-200 p-4">
              <div className="mb-4">
                <h3 className="font-medium text-gray-900">
                  {selectedExt.displayName || selectedExt.name}
                </h3>
                {selectedExt.description && (
                  <p className="text-sm text-gray-500">{selectedExt.description}</p>
                )}
              </div>
              <ExtensionUiLoader extensionName={selectedExt.name} />
            </div>
          ) : (
            <p className="text-sm text-gray-500">Select an extension from the list.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExtensionsTab;
